export default __webpack_public_path__ + "static/media/btn-index-sound-on.a15331ca.svg";